'use client';
import { create } from 'zustand';
import { ActionFeedbackProps } from '../../ui/shared/module-actions-feedback';

type UpdatePasswordState = {
  actionFeedback: ActionFeedbackProps | null;
  error: Error | null;
  isLoading: boolean;
  setActionFeedback: (feedback: ActionFeedbackProps | null) => void;
  setIsLoading: (status: boolean) => void;
  setError: (error: Error | null) => void;
};

export const useUpdatePasswordStore = create<UpdatePasswordState>((set) => ({
  actionFeedback: null,
  error: null,
  isLoading: false,
  setIsLoading: (isLoading: boolean) => set({ isLoading }),
  setError: (error: Error | null) => set({ error }),
  setActionFeedback: (actionFeedback) => set({ actionFeedback }),
}));
